import React from "react";

import LegalPage from "views/legal/LegalPage";

const sections = [
  {
    title: "1. Kullanıcı Olarak Haklarınız",
    paragraphs: [
      "Destinasyon 360 kullanıcıları, platformda işlenen kişisel verileri hakkında bilgi alma, erişim talep etme, hatalı bilgilerin düzeltilmesini isteme, belirli koşullarda silme veya işlemeyi kısıtlama talebinde bulunma haklarına sahiptir.",
      "Bu haklar üyelik durumu fark etmeksizin geçerlidir. Hesabınız olmasa bile bizimle paylaştığınız iletişim, rezervasyon veya destek taleplerine ilişkin veriler için başvuru yapabilirsiniz.",
    ],
  },
  {
    title: "2. Hesap ve Profil Gizliliği",
    items: [
      "Profil bilgileriniz, rezervasyonlarınız, favorileriniz ve bildirim tercihleriniz hesabınıza bağlı olarak saklanır.",
      "Hesap bilgilerinizi yalnızca yetkili ekipler, hizmeti sunmak veya destek talebinizi çözmek için gerekli olduğunda görüntüleyebilir.",
      "Şifrenizi, oturum bilgilerinizi ve yönetim paneli erişiminizi üçüncü kişilerle paylaşmamanız gerekir.",
    ],
  },
  {
    title: "3. Rezervasyon ve İşletme Etkileşimleri",
    paragraphs: [
      "Bir işletmeye rezervasyon, teklif veya iletişim talebi gönderdiğinizde, talebin karşılanabilmesi için gerekli bilgiler ilgili işletme veya partner hesabı ile paylaşılabilir.",
      "İşletmeler bu bilgileri yalnızca talebi yanıtlamak, rezervasyon sürecini yürütmek ve kullanıcıyla ilgili hizmeti sağlamak amacıyla kullanmalıdır.",
    ],
  },
  {
    title: "4. Favoriler, Bildirimler ve Kişiselleştirme",
    paragraphs: [
      "Kaydettiğiniz işletmeler, favori içerikleriniz, uyarılarınız ve keşif tercihleriniz size daha ilgili destinasyon, kampanya ve rota önerileri sunmak için kullanılabilir.",
      "Bildirim tercihlerinizi dilediğiniz zaman uygulama üzerinden değiştirebilir veya belirli iletişimleri kapatabilirsiniz.",
    ],
  },
  {
    title: "5. Konum ve Harita Kullanımı",
    paragraphs: [
      "Harita ve yakın çevre keşfi gibi özellikler, yaklaşık konum bilgisi veya sizin seçtiğiniz şehir/ilçe bilgileri üzerinden çalışabilir.",
      "Konum paylaşımı cihazınızın ve tarayıcınızın izinlerine bağlıdır. Konum iznini kapattığınızda bazı harita ve yakın öneri özellikleri sınırlı çalışabilir.",
    ],
  },
  {
    title: "6. Veri Talepleri",
    items: [
      "Erişim: Hangi verilerinizin işlendiğini öğrenebilirsiniz.",
      "Düzeltme: Eksik veya hatalı bilgilerin güncellenmesini isteyebilirsiniz.",
      "Silme: Yasal saklama yükümlülükleri dışında kalan verilerinizin silinmesini talep edebilirsiniz.",
      "İtiraz: Pazarlama veya kişiselleştirme amaçlı bazı işlemlere itiraz edebilirsiniz.",
      "Taşınabilirlik: Uygulanabilir olduğunda verilerinizin okunabilir formatta paylaşılmasını isteyebilirsiniz.",
    ],
  },
  {
    title: "7. Çocukların Gizliliği",
    paragraphs: [
      "Destinasyon 360 genel kitleye yönelik bir seyahat ve işletme keşif platformudur. 18 yaş altı kullanıcıların kişisel veri paylaşımı için veli veya yasal temsilci gözetimi önerilir.",
      "Çocuklara ait verilerin izinsiz işlendiğini düşünüyorsanız bizimle iletişime geçebilirsiniz.",
    ],
  },
  {
    title: "8. Başvuru ve Yanıt Süreci",
    paragraphs: [
      "Gizlilik taleplerinizi uygulama içindeki destek kanalları veya resmi destek e-posta adresi üzerinden iletebilirsiniz. Talebin size ait olduğunu doğrulamak için ek bilgi isteyebiliriz.",
      "Başvurular makul süre içinde değerlendirilir ve yürürlükteki mevzuatın izin verdiği kapsamda yanıtlanır.",
    ],
  },
];

const UserPrivacy = () => (
  <LegalPage
    title="Kullanıcı Gizliliği"
    subtitle="Kullanıcıların veri haklarını, tercihlerini ve Destinasyon 360 içindeki gizlilik kontrollerini açıklar."
    lastUpdated="12 Mayıs 2026"
    intro="Bu sayfa, Destinasyon 360 kullanıcılarının kişisel verileri üzerindeki haklarını ve platformdaki gizlilik tercihlerini daha anlaşılır hale getirmek için hazırlanmıştır."
    sections={sections}
  />
);

export default UserPrivacy;
